/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Summary_AngleInputs */

const en_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const de_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const fr_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const es_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const it_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const nl_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const pl_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const fi_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const da_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

const sv_deep_match_summary_angle = /** @type {(inputs: Deep_Match_Summary_AngleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary Angle`)
};

/**
* | output |
* | --- |
* | "Summary Angle" |
*
* @param {Deep_Match_Summary_AngleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_summary_angle = /** @type {((inputs?: Deep_Match_Summary_AngleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Summary_AngleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_summary_angle(inputs)
	if (locale === "fr") return fr_deep_match_summary_angle(inputs)
	if (locale === "es") return es_deep_match_summary_angle(inputs)
	if (locale === "it") return it_deep_match_summary_angle(inputs)
	if (locale === "nl") return nl_deep_match_summary_angle(inputs)
	if (locale === "pl") return pl_deep_match_summary_angle(inputs)
	if (locale === "fi") return fi_deep_match_summary_angle(inputs)
	if (locale === "da") return da_deep_match_summary_angle(inputs)
	if (locale === "sv") return sv_deep_match_summary_angle(inputs)
	return en_deep_match_summary_angle(inputs)
});